import { trpc } from './trpc'
import { useToast } from '@/components/ui/use-toast'

// Request new feature via Slack
export const useRequestFeature = () => {
    const { toast } = useToast()

    return trpc.feedback.requestFeature.useMutation({
        onSuccess: () => {
            toast({
                title: 'Success',
                description: 'Feature request sent successfully. Thank you for your feedback!',
            })
        },
        onError: (error) => {
            toast({
                title: 'Error',
                description: error.message,
                variant: 'destructive',
            })
        },
    })
}
